import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const T = "#00c896";
const N = "#0f2040";

const CoverEKYC = () => (
  <svg viewBox="0 0 860 420" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="860" height="420" fill={N}/>
    <circle cx="430" cy="210" r="180" fill="rgba(0,200,150,0.04)" stroke="rgba(0,200,150,0.12)" strokeWidth="1"/>
    <circle cx="430" cy="210" r="130" fill="rgba(0,200,150,0.06)" stroke="rgba(0,200,150,0.18)" strokeWidth="1"/>
    <circle cx="430" cy="210" r="80" fill="rgba(0,200,150,0.08)" stroke={T} strokeWidth="1.5" strokeDasharray="6 4"/>
    {/* Face */}
    <ellipse cx="430" cy="198" rx="42" ry="50" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5"/>
    <circle cx="416" cy="186" r="5" fill={T} opacity="0.8"/><circle cx="444" cy="186" r="5" fill={T} opacity="0.8"/>
    <path d="M420 212 q10 8 20 0" stroke={T} strokeWidth="2" strokeLinecap="round" fill="none"/>
    {/* Scan line */}
    <line x1="350" y1="198" x2="510" y2="198" stroke={T} strokeWidth="1.5" opacity="0.6" strokeDasharray="4 2"/>
    {/* Corner brackets */}
    {([[298,128],[562,128],[298,292],[562,292]] as [number,number][]).map(([cx,cy],i) => (
      <g key={i}>
        <line x1={cx} y1={cy} x2={cx+(i%2===0?16:-16)} y2={cy} stroke={T} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1={cx} y1={cy} x2={cx} y2={cy+(i<2?16:-16)} stroke={T} strokeWidth="2.5" strokeLinecap="round"/>
      </g>
    ))}
    {/* Landmark dots */}
    {[[430,150],[390,176],[470,176],[410,222],[450,222],[430,248]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="3" fill={T} opacity="0.5"/>
    ))}
    {/* Status badge */}
    <rect x="330" y="310" width="200" height="48" rx="24" fill={T}/>
    <text x="430" y="330" fontSize="11" fontWeight="800" fill={N} textAnchor="middle" fontFamily="system-ui">✓ IDENTITY VERIFIED</text>
    <text x="430" y="348" fontSize="10" fill={N} textAnchor="middle" fontFamily="system-ui" opacity="0.7">Match score: 99.2%</text>
    {/* Grid dots bg */}
    {Array.from({length:8}).map((_,row) => Array.from({length:16}).map((_,col) => (
      <circle key={`${row}-${col}`} cx={col*60+30} cy={row*60+30} r="1" fill="rgba(255,255,255,0.04)"/>
    )))}
  </svg>
);

const CoverOJK = () => (
  <svg viewBox="0 0 860 420" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="860" height="420" fill="#0a1628"/>
    {/* Document */}
    <rect x="280" y="60" width="300" height="300" rx="16" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5"/>
    <rect x="280" y="60" width="300" height="52" rx="16" fill="rgba(0,200,150,0.15)"/>
    <rect x="280" y="96" width="300" height="16" fill="rgba(0,200,150,0.1)"/>
    <text x="430" y="92" fontSize="11" fontWeight="800" fill={T} textAnchor="middle" fontFamily="system-ui">PERATURAN OJK NO. 12/2024</text>
    {/* Lines */}
    {[0,1,2,3,4,5,6,7].map(i => (
      <rect key={i} x="304" y={136+i*26} width={i%3===2?140:220} height="8" rx="4" fill="rgba(255,255,255,0.08)"/>
    ))}
    {/* Stamp */}
    <circle cx="480" cy="300" r="44" fill="rgba(0,200,150,0.1)" stroke={T} strokeWidth="2" strokeDasharray="5 3"/>
    <circle cx="480" cy="300" r="34" fill="rgba(0,200,150,0.15)" stroke={T} strokeWidth="1.5"/>
    <text x="480" y="296" fontSize="10" fontWeight="800" fill={T} textAnchor="middle" fontFamily="system-ui">OJK</text>
    <text x="480" y="310" fontSize="8" fill={T} textAnchor="middle" fontFamily="system-ui">CERTIFIED</text>
    {/* Shield left */}
    <path d="M160 160 L200 140 L240 160 L240 220 C240 260 200 280 200 280 C200 280 160 260 160 220 Z" fill="rgba(0,200,150,0.1)" stroke={T} strokeWidth="1.5"/>
    <path d="M186 208l10 10 20-20" stroke={T} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="200" y="298" fontSize="9" fill="rgba(255,255,255,0.4)" textAnchor="middle" fontFamily="system-ui">Compliant</text>
    {/* Right side nodes */}
    {["eKYC","AML","KYB","PPATK"].map((label,i) => (
      <g key={i}>
        <rect x="620" y={100+i*72} width="100" height="36" rx="8" fill="rgba(0,200,150,0.1)" stroke="rgba(0,200,150,0.25)" strokeWidth="1"/>
        <text x="670" y={122+i*72} fontSize="9" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">✓ {label}</text>
        <line x1="580" y1={118+i*72} x2="620" y2={118+i*72} stroke="rgba(0,200,150,0.3)" strokeWidth="1" strokeDasharray="3 2"/>
      </g>
    ))}
  </svg>
);

const CoverAML = () => (
  <svg viewBox="0 0 860 420" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="860" height="420" fill="#0f1f3d"/>
    {/* Radar */}
    {[160,120,80,40].map((r,i) => (
      <circle key={i} cx="430" cy="210" r={r} stroke="rgba(0,200,150,0.15)" strokeWidth="1" fill="none"/>
    ))}
    {/* Sweep */}
    <path d="M430 210 L430 50 A160 160 0 0 1 570 300 Z" fill="rgba(0,200,150,0.05)"/>
    <line x1="430" y1="210" x2="430" y2="50" stroke={T} strokeWidth="1" opacity="0.4"/>
    <line x1="430" y1="210" x2="570" y2="300" stroke={T} strokeWidth="1" opacity="0.4"/>
    {/* Hit nodes */}
    {[{x:310,y:100,label:"PEP",c:"#ef4444"},{x:555,y:130,label:"SDN",c:"#ef4444"},{x:540,y:310,label:"WL",c:"#f59e0b"},{x:290,y:300,label:"OK",c:T}].map((n,i) => (
      <g key={i}>
        <line x1="430" y1="210" x2={n.x} y2={n.y} stroke={n.c} strokeWidth="1" strokeDasharray="4 3" opacity="0.5"/>
        <circle cx={n.x} cy={n.y} r="22" fill={n.c} opacity="0.12" stroke={n.c} strokeWidth="1.5"/>
        <text x={n.x} y={n.y+5} fontSize="9" fontWeight="700" fill={n.c} textAnchor="middle" fontFamily="system-ui">{n.label}</text>
      </g>
    ))}
    <circle cx="430" cy="210" r="18" fill="rgba(0,200,150,0.2)" stroke={T} strokeWidth="2"/>
    <text x="430" y="215" fontSize="9" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">AML</text>
    {/* Stats right */}
    <rect x="640" y="120" width="160" height="180" rx="12" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
    <text x="720" y="148" fontSize="11" fontWeight="700" fill="rgba(255,255,255,0.7)" textAnchor="middle" fontFamily="system-ui">Screening Results</text>
    {[{l:"PEP",v:"2 hits",c:"#ef4444"},{l:"Sanctions",v:"Clear",c:T},{l:"Watchlist",v:"1 match",c:"#f59e0b"},{l:"Adverse",v:"Clear",c:T}].map((r,i) => (
      <g key={i}>
        <text x="656" y={174+i*34} fontSize="9" fill="rgba(255,255,255,0.4)" fontFamily="system-ui">{r.l}</text>
        <text x="656" y={188+i*34} fontSize="11" fontWeight="700" fill={r.c} fontFamily="system-ui">{r.v}</text>
      </g>
    ))}
  </svg>
);

const CoverFraud = () => (
  <svg viewBox="0 0 860 420" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="860" height="420" fill="#0a1628"/>
    {/* Shield */}
    <path d="M430 60 L310 110 L310 230 C310 310 430 360 430 360 C430 360 550 310 550 230 L550 110 Z"
      fill="rgba(0,200,150,0.08)" stroke={T} strokeWidth="2"/>
    <path d="M430 60 L310 110 L310 230 C310 310 430 360 430 360 C430 360 550 310 550 230 L550 110 Z"
      fill="none" stroke="rgba(0,200,150,0.3)" strokeWidth="1" strokeDasharray="6 4"/>
    <path d="M390 210 l28 28 52-52" stroke={T} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Pulse rings */}
    {[80,110,140].map((r,i) => (
      <circle key={i} cx="430" cy="210" r={r} stroke="rgba(0,200,150,0.08)" strokeWidth="1" fill="none"/>
    ))}
    {/* Threat badges */}
    {[
      {x:160,y:140,label:"Spoof Blocked",c:"#ef4444"},
      {x:160,y:290,label:"Bot Detected",c:"#f59e0b"},
      {x:640,y:140,label:"Geo Anomaly",c:"#ef4444"},
      {x:640,y:290,label:"Velocity OK",c:T},
    ].map((b,i) => (
      <g key={i}>
        <rect x={b.x-60} y={b.y-14} width={120} height={28} rx={14} fill={b.c} opacity={0.12} stroke={b.c} strokeWidth={1}/>
        <text x={b.x} y={b.y+5} fontSize="9" fontWeight="700" fill={b.c} textAnchor="middle" fontFamily="system-ui">{b.label}</text>
        <line x1={i<2?b.x+60:b.x-60} y1={b.y} x2={i<2?310:550} y2={210}
          stroke={b.c} strokeWidth="1" strokeDasharray="4 3" opacity="0.4"/>
      </g>
    ))}
    {/* Score */}
    <text x="430" y="370" fontSize="11" fill="rgba(255,255,255,0.35)" textAnchor="middle" fontFamily="system-ui">Fraud Risk Score: LOW (12/100)</text>
  </svg>
);

const blogSlides = [
  {
    cover: <CoverEKYC />,
    tag: "# eKYC Guide",
    title: "What is eKYC and why every Indonesian fintech needs it in 2025",
    content: "Electronic Know Your Customer (eKYC) is now mandatory for all OJK-regulated financial services. Here's what it means for your product and how to implement it correctly.",
  },
  {
    cover: <CoverOJK />,
    tag: "# Compliance",
    title: "OJK's POJK No. 12/2024 eKYC regulation — what changed and what it means for you",
    content: "The new OJK regulation expands eKYC requirements to include passive liveness, document OCR, and AML screening at onboarding. We break down every key clause.",
  },
  {
    cover: <CoverAML />,
    tag: "# AML & Compliance",
    title: "PEP, sanctions, and watchlist screening: what's the difference and why all three matter",
    content: "Most fintechs screen against one list. OJK compliance requires all three — Politically Exposed Persons, OFAC/UN sanctions, and domestic watchlists. Here's why.",
  },
  {
    cover: <CoverFraud />,
    tag: "# Fraud Prevention",
    title: "How passive liveness detection stops 99.8% of spoofing attacks",
    content: "Active liveness (blinking, nodding) is increasingly beatable. We explain why passive 3D liveness with anti-spoofing is the new gold standard for identity verification.",
  },
];

const BlogSlider: React.FC = () => {
  return (
    <section className="blog pt-70">
      <div className="container">
        <div className="blog-slider pos-rel">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".blog-swiper-btn.swiper-button-next",
              prevEl: ".blog-swiper-btn.swiper-button-prev",
            }}
            className="swiper-container"
          >
            {blogSlides.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="blog-slide-item">
                  <div className="xb-item--img" style={{ overflow: "hidden", borderRadius: 12 }}>
                    {item.cover}
                  </div>
                  <div className="xb-item--holder">
                    <Link to="/blog-details" className="xb-item--tag xb-border">{item.tag}</Link>
                    <h2 className="xb-item--title">
                      <Link to="/blog-details">{item.title}</Link>
                    </h2>
                    <p className="xb-item--content">{item.content}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="swiper-pagination"></div>

          <div className="blog-item_button">
            <div className="blog-swiper-btn swiper-button-prev">
              <i className="fa-regular fa-angles-left"></i>
            </div>
            <div className="blog-swiper-btn swiper-button-next">
              <i className="fa-regular fa-angles-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSlider;
